var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ay2oa2uyea",
    d: "M0 0.809L15.263 0.809 15.263 15.999 0 15.999z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M11.362 0s-1.71.008-2.94 1.741c-1.094 1.54-.816 2.857-.816 2.857s.09.017.246.017c.475 0 1.56-.156 2.542-1.418C11.617 1.628 11.362 0 11.362 0m-1.13 1.385c-.113.368-.305.784-.627 1.198-.31.397-.622.644-.901.795.095-.31.259-.672.533-1.059.315-.444.668-.739.995-.934",
    transform: "translate(-122 -362) translate(122 362.5)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-122 -362) translate(122 362.5) translate(0 4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "moqt6214tb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ay2oa2uyea"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M11.099.81c-1.53 0-2.703.928-3.337.928-.736 0-1.837-.872-3.255-.872C2.326.866 0 2.95 0 6.928c0 4.043 2.747 9.07 4.922 9.07.759 0 1.925-.816 3.1-.816 1.152 0 2.003.787 3.097.787 2.38 0 4.144-5.302 4.144-5.302S12.74 9.627 12.74 6.6c0-2.684 2.025-3.79 2.025-3.79s-1.035-2-3.667-2m0 1c1.097 0 1.828.442 2.264.84-.73.715-1.622 1.99-1.622 3.95 0 2.459 1.364 3.845 2.296 4.505-.73 1.81-1.974 3.865-2.918 3.865-.348 0-.714-.146-1.137-.315-.556-.22-1.185-.471-1.96-.471-.838 0-1.615.3-2.238.542-.3.115-.71.273-.862.273C3.69 15 1 10.95 1 6.93c0-3.29 1.807-5.064 3.507-5.064.626 0 1.203.238 1.76.467.509.209.989.407 1.495.407.454 0 .882-.184 1.377-.397.579-.25 1.235-.532 1.96-.532",
    mask: "url(#moqt6214tb)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo12);
export default __webpack_public_path__ + "static/media/gamelogo12.da6b7bd8d4506f9f6a12be00807f40ed.svg";
export { ForwardRef as ReactComponent };